/** Plan – Unlocked moves modal (Figma 96138:33274). */
export const PLAN_UNLOCKED_MOVES_MODAL_Z_INDEX = 1060;

export const PLAN_UNLOCKED_MOVES_MODAL_PROPS = {
  zIndex: PLAN_UNLOCKED_MOVES_MODAL_Z_INDEX,
  className:
    "[--modal-radius:0px] md:[--modal-radius:12px] [--modal-height:100dvh] md:[--modal-height:min(852px,100dvh)] [--modal-width:100%] md:[--modal-width:393px]",
  contentStyle: {
    borderRadius: "var(--modal-radius)",
    width: "var(--modal-width)",
    height: "var(--modal-height)",
    maxHeight: "100dvh",
    overflow: "hidden" as const,
    padding: 0,
  },
  styles: {
    body: {
      height: "100%",
      padding: 0,
    },
  },
  containerClassName: "flex h-full flex-col overflow-hidden",
  containerStyle: {
    height: "100%",
    width: "100%",
    maxHeight: "100%",
    overflow: "hidden" as const,
  },
  titleStyle: {
    minHeight: 0,
  },
  showClose: false,
  maskClosable: true,
  destroyOnClose: true,
} as const;
